import PropTypes from 'prop-types';
import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FilledInput from '@mui/material/FilledInput';
import InputLabel from '@mui/material/InputLabel';

const Input = ({
  className,
  inputInfo,
  inputValue,
  inputHasError,
  onChangeInput,
  onBlurInput,
}) => {
  const { id, name, errMessage, type } = inputInfo;

  return (
    <FormControl className={`${className || ''}`} error={inputHasError}>
      <InputLabel htmlFor={id}>{name}</InputLabel>
      {type === 'oneline' ? (
        <FilledInput
          id={id}
          name={`user-${id}`}
          value={inputValue}
          onChange={onChangeInput}
          onBlur={onBlurInput}
        />
      ) : (
        <FilledInput
          name={`user-${id}`}
          id={id}
          value={inputValue}
          onChange={onChangeInput}
          onBlur={onBlurInput}
          multiline
          rows={4}
        />
      )}

      {inputHasError && (
        <FormHelperText id={`${id}-text`}>{errMessage}</FormHelperText>
      )}
    </FormControl>
  );
};

Input.propTypes = {
  className: PropTypes.string,
  inputInfo: PropTypes.object,
  inputValue: PropTypes.string,
  inputHasError: PropTypes.bool,
  onChangeInput: PropTypes.func,
  onBlurInput: PropTypes.func,
};

export default Input;
